export class TimeUtils{


    public static cutToSeconds(time:number):number {
        return (time - (time % 1000)) / 1000;
    }
    
    public static addWeeks(date:Date, weeks:number):Date {
        return this.addDays(date, weeks*7);
    }

    public static addDays(date:Date, days:number):Date {
        return this.addHours(date, days*24);
    }

    public static addHours(date:Date, hrs:number):Date {
        return this.addMinutes(date, hrs*60);
    }

    public static addMinutes(date:Date, mins:number):Date {
        return this.addSeconds(date, mins*60);
    }

    public static addSeconds(date:Date, secs:number):Date {
        var mSecs:number = secs * 1000;
        var sum:number = mSecs + date.getTime();
        return new Date(sum);
    }

    public static addMiliSeconds(date:Date, ms:number):Date {
        var sum:number = ms + date.getTime();
        return new Date(sum);
    }
    public static subtractMiliSeconds(date:Date, ms:number):Date {
        var sum:number = date.getTime() - ms;
        return new Date(sum);
    }

    public static convertToTimeString( tmp:number, withHours:Boolean=true ) : string {
        var seconds:number = Math.floor((tmp / 1000)) % 60;
        tmp = Math.floor((tmp / 1000));
        var minutes:number = Math.floor((tmp / 60)) % 60;
        tmp = Math.floor((tmp / 60));
        var hours:number = Math.floor(tmp / 60);
        if( withHours ){
            return ((hours < 10) ? "0" + hours : hours) + ":" + ((minutes < 10) ? "0" + minutes : minutes) + ":" + ((seconds < 10) ? "0" + seconds : seconds );		
        }else {
            if ( hours != 0 ) {
                return ((hours < 10) ? "0" + hours : hours) + ":" + ((minutes < 10) ? "0" + minutes : minutes) + ":" + ((seconds < 10) ? "0" + seconds : seconds );			
            }else {
                return ((minutes < 10) ? "0" + minutes : minutes) + ":" + ((seconds < 10) ? "0" + seconds : seconds );		
            }
        }
    }
        
    public static convertToHourMinutesSecondsString(time:number):string {
        var tmp:number = TimeUtils.subtractMiliSeconds(new Date(), time ).getTime();
        return this.convertToTimeString( tmp );
    }

    public static convertTominutesString(time:number):string {
        var tmp:number = time;
        var seconds:number = Math.floor((tmp / 1000)) % 60;
        tmp = Math.floor(tmp / 1000);
        var minutes:number = Math.floor(tmp / 60) % 60;
                
                
        return ((minutes < 10) ? "0" + minutes : minutes) + ":" + ((seconds < 10) ? "0" + seconds : seconds)
    }

}